module.exports = __webpack_public_path__ + "static/media/janahitha.dc3b3d86.png";